import { defineComponent as _defineComponent } from 'vue'
import { PaymentReport } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import { ref, PropType, computed } from 'vue';
import { usePaymentState } from 'ah-payments';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentsCancelModal',
  props: {
  payment: {
    type: Object as PropType<PaymentReport>,
    required: true,
  },
},
  emits: ["cancel-payment"],
  setup(__props, { emit }: { emit: ({
  (e: 'cancel-payment'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const paymentCancelModal = ref<InstanceType<typeof BModal> | null>(null);

const paymentState = usePaymentState();
const requestManager = useRequestManager({
  exposeToParent: true,
}).manager;

const onBehalfOfClient = useOnBehalfOf();





function showModal() {
  paymentCancelModal.value!.show();
}

function hideModal() {
  paymentCancelModal.value!.hide();
}

function deletePayment() {
  requestManager
    .cancelAndNew(
      'cancelPayment',
      paymentState.services.payments.cancelPayment(props.payment?.id, onBehalfOfClient.value?.id).pipe()
    )
    .subscribe(
      () => {
        paymentState.toast.success(`Payment ${props.payment?.referenceNumber} cancelled successfully`);
        emit('cancel-payment');
        hideModal();
      },
      () => {
        paymentState.toast.error('An unexpected problem has occurred. Please try again later.');
        hideModal();
      }
    );
}

const isCancelling = computed(() => {
  return requestManager.requestStates.cancelPayment === 'pending';
});

return { __sfc: true,paymentCancelModal, paymentState, requestManager, onBehalfOfClient, emit, props, showModal, hideModal, deletePayment, isCancelling, BModal }
}

})